<template>
  <div class="grid-item" @click="showDialog">
    <Line :data="data" :options="options" />
  </div>
</template>

<script>
import {Line} from 'vue-chartjs';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Colors 
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Colors
)



export default {
  name: 'LineCompanyChart',
  props:['data'],
  components: { Line },

  setup(props){
    const data = {
      labels: props.data.date_datasets,
      datasets: props.data.datasets
    }
    const options = {
      responsive: true,
      pointBorderWidth:3,
      borderWidth: 2
    }

    return{data,options}      
  },
};
</script>


<style scoped>
.grid-item{
  width: 900px;
  height: 400px;
}

</style>